<div class="w-full mt-[133px] pb-[102px] flex flex-col items-center">
    <img src="images/landing/lets-connect.svg" alt="lets connect" class="h-[40px] mb-[18px]" />
    <div class="flex flex-col items-center">
        <div class="mt-[31px] mb-[56px] px-4 sm:px-[12%] text-center text-sm sm:text-base">
            <p class="mb-4">
                SEM Nexus is ready to help you find unique solutions for your app. Get in touch to learn more about your
                project
                and receive the full SEM Nexus treatment.
            </p>
            <p class="mt-4">
                By partnering with SEM Nexus, you can confidently launch your app and get your product into the hands of
                customers, achieving unparalleled mobile growth.
            </p>
        </div>
        <app-button buttonText="get in touch now!" (click)="scheduleCall()"></app-button>
    </div>
</div>